
import { defineComponent, reactive, toRefs } from 'vue';
import Overlay from '../../components/Overlay.vue';
import VChart from 'vue-echarts';

export default defineComponent({
  name: 'DashboardStorageHistory',

  components: {
    Overlay,
    VChart,
  },

  props: {
    totalStock: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    day: {
      type: Array as () => Array<string>,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const propsRef = toRefs(props);
    const state = reactive({
      options: {
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '15%',
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: propsRef.day,
          axisLine: { show: true },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        series: [
          {
            name: 'Estoque',
            type: 'line',
            data: propsRef.totalStock,
            color: '#999697',
            label: {
              show: true,
              color: '#000',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
        ],
      },
    });
    return { ...toRefs(state) };
  },
});
